import React, { useEffect, useState } from 'react';
import { SPLeadModel } from '../models/superbit-api-models';
import LeadItemRow from './_LeadItemRow';
import { Dropdown, Select } from 'antd';

import './leads-table.css';

type Props = {
    data: any[];
    config?: any;
    actions?: Function[]
};

const LeadsTable =(props: Props)=> {
    const [leads, setLeads] = useState<SPLeadModel[]>([]);

    const emptyFunc = (value?: string) => {}

    useEffect(()=>{
        setLeads(props.data);
    },[props.data]);
    useEffect(()=>{
        if (leads.length>0) console.log('New list loaded', leads)
    },[leads])
    
    return (
        <>
        <div className='content-header client-leads-list-header'>
            <div className="content-table-header flex-space-between flex-centered">
                <div className="cell icon">
                </div>
                <div className="cell status">
                    סטטוס
                </div>
                <div className="cell date-field">
                    ת. יצירה
                </div>
                <div className="cell branch-name">
                    סניף
                </div>
                <div className="cell position-name">
                    עמדה
                </div>
                <div className="cell handler-name">
                    מטפל
                </div>
                <div className="cell contact-name">
                    איש קשר
                </div>
                <div className="cell phone-number">
                טלפון
                </div>
                <div className="cell icon">
                
                </div>
                <div className="cell asset-name">
                    נכס
                </div>
                <div className="cell lead-type">
                    סוג ליד
                </div>
                <div className="cell year-field">
                    שנה
                </div>
                <div className="cell notes">
                    הערות
                </div>
                <div className="cell date-field">
                    ת.מסירה / תחילת ביטוח
                </div>
                <div className="cell actions">
                
                </div>
            </div>
            {/* <div className='leads-table-header-row'>
                <div className="cell icon">
                </div>
                <div className="cell status">
                    סטטוס
                </div>
                <div className="cell date-field">
                    ת. יצירה
                </div>
                <div className="cell branch-name">
                    סניף
                </div>
                <div className="cell position-name">
                    עמדה
                </div>
                <div className="cell handler-name">
                    מטפל
                </div>
                <div className="cell contact-name">
                    איש קשר
                </div>
                <div className="cell phone-number">
                טלפון
                </div>
                <div className="cell icon">
                
                </div>
                <div className="cell asset-name">
                    נכס
                </div>
                <div className="cell lead-type">
                    סוג ליד
                </div>
                <div className="cell year-field">
                    שנה
                </div>
                <div className="cell notes">
                    הערות
                </div>
                <div className="cell date-field">
                    ת.מסירה / תחילת ביטוח
                </div>
                <div className="cell actions">
                
                </div>
            </div> */}
        </div>
        {leads.length > 0 ? (
            <div className='leads-item-list'>
            {leads.map((leadData: any)=> {
                return (
                    <>
                    <LeadItemRow details={leadData}></LeadItemRow>
                    </>
                )
            })}
            </div>
        ):(<></>)}
        
        </>
    )
}




export default LeadsTable;